import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSnackbar } from 'notistack';
import { useDropzone } from 'react-dropzone';
import KenUploadButton from './Components/KenUploadButton';
import AttachFileIcon from '@mui/icons-material/AttachFile';

const useStyles = makeStyles((theme) => ({
  card: {
    margin: 16,
  },
  cardContainer: {
    padding: 8,
  },
  rowWrap: {
    marginBottom: 32,
    paddingBottom: 14,
  },
  rowWrapConditional: {
    marginBottom: 0,
    borderBottom: 0,
  },
  rowLabel: {
    fontWeight: 500,
    color: '#091E42',
  },
  rowDesc: {
    maxWidth: '400px',
    color: '#7A869A',
  },
  mainContent: {
    position: 'relative',
  },
}));

const convertArrayToObject = (array) => {
  const result = {};
  array.forEach((item) => {
    result[item] = [];
  });
  return result;
};

export default function KenDocumentUpload(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { value = [], label, recordId, onChange, accept, handleDownload } = props;
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    multiple: false,
    noKeyboard: true,
    accept: convertArrayToObject(accept?.split(',') || []),
    maxSize: 3000000,
    onDrop: (acceptedFiles, fileRejections) => {
      console.log(acceptedFiles, fileRejections, 'files');
      if (fileRejections.length > 0) {
        enqueueSnackbar(fileRejections[0]?.errors[0]?.message.replace('2000000 bytes', '2 MB'), {
          variant: 'error',
        });
      } else {
        const allowedTypes = accept?.split(',') || [];
        const fileType = acceptedFiles[0]?.type;
        if (allowedTypes.some((type) => fileType.includes(type))) {
          onChange([...value, ...acceptedFiles]);
        } else {
          enqueueSnackbar(`${props.Supported_File_Types__c.split(';').join(', ')} is allowed`, {
            variant: 'error',
          });
        }
      }
    },
  });

  return (
    <Box component={'div'} {...getRootProps({ className: 'dropzone' })} className="d-flex flex-column w-100" gap={'12px'} width={'max-content'}>
      {!isMobileScreen && (
        <Typography component={'h6'} color={'#373A45'} variant="medium">
          {label}<span style={{color:"red"}}>*</span>
        </Typography>
      )}
      <Box component={'div'} className="w-100">
        <input {...getInputProps()} />
        {isMobileScreen ? (
          <Box
            onClick={() => {
              open();
            }}
            component={'div'}
            sx={{
              border: '1px solid #8871B8',
              padding: '12px',
              borderRadius: '8px',
            }}
            className="d-flex align-items-center w-100 justify-content-between"
          >
            <Typography color={'#B0B0B0'} variant="smallthin">
              {props?.label}
            </Typography>
            <AttachFileIcon sx={{ color: '#8A8A8A', fontSize: '20px' }} />
          </Box>
        ) : (
          <KenUploadButton open={open} recordId={recordId} fileName={props?.fileName} fileType={props?.accept} handleDownload={handleDownload} />
        )}
      </Box>
      <Box component={'div'} className="d-flex align-items-center gap-1 pt-3">
        <Typography variant="extrasmallthin" color={'#B0B0B0'}>
          Supported File Type: {props?.Supported_File_Types__c?.split(';')?.join(', ')}
        </Typography>
        <Typography variant="extrasmallthin" color={'#B0B0B0'}>
          Maximum File Size: {props?.Maximum_File_Size__c}MB{' '}
        </Typography>
      </Box>
    </Box>
  );
}
